import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FC, memo, ReactNode } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { COLOR, Spacing, SpacingRecord, VariantBodyType } from '../../theme/type';
import { colorToCss } from '../../theme/utils';
import { getMargin, getPadding } from '../../utils/spacing';

const MARGIN_FALLBACK: SpacingRecord = { y: { md: '0.75em', xs: '0.5em' } };

type ParagraphProps = {
  bold?: boolean;
  center?: boolean;
  children?: ReactNode;
  color?: COLOR;
  margin?: Spacing;
  padding?: Spacing;
  variant?: VariantBodyType;
};

const Paragraph: FC<ParagraphProps> = ({
  bold = false,
  center = false,
  children,
  color,
  margin,
  padding,
  variant = 'body1',
}) => {
  const sx = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      color: colorToCss(color),
      fontWeight: bold ? 'bold' : undefined,
      textAlign: center ? 'center' : 'inherit',
      ...getMargin(margin, MARGIN_FALLBACK),
      ...getPadding(padding),
    }),
    [bold, center, color, margin, padding]
  );

  return (
    <Typography sx={sx} variant={variant}>
      {children}
    </Typography>
  );
};

export default memo(Paragraph);
